module.exports = __webpack_public_path__ + "img/hero-title-h5.7d31d8c3.png";